import { PropsWithChildren } from 'react';

type WhenProps = {
  expr: boolean;
}

/**
 * Renders the contents if the condition is met.
 *
 * @param props A collection of properties.
 * @returns A JSX element or false.
 */
export const When = ({ children, expr }: PropsWithChildren<WhenProps>) => {
  if (expr) {
    return (
      <>{children}</>
    )
  }
  return null;
}
